import { onboardingStepsSettings } from 'reactApp/appHelpers/featuresHelpers/features/onboardingSteps';
import { toDaysFromMS } from 'reactApp/utils/Period';

const showTimeMS = onboardingStepsSettings?.showTimeMS ?? 0;

export const ONBOARDING_STEPS_VISIBILITY_DURATION = toDaysFromMS(showTimeMS); // 7 дней
export const ONBOARDING_OPENING_DELAY_MS = 10 * 1000; // 10 секунд перед раскрытием в первый раз на одном из шагов
export const ONBOARDING_PROGRESS_KEY = 'onboarding.steps.progress';
export const ONBOARDING_STATE_KEY = 'onboarding.steps.state';
export const COMPLETION_STATE = 'completed';

export enum AnyliticsCategories {
    STEPS = 'onbording-steps',
}

export enum AnyliticsActions {
    SHOW = 'show',
    CLICK = 'click',
    PAYMENT_SUCCESS = 'payment-success',
}

export enum AnalyticButtonName {
    DOWNLOAD = 'download-app',
    GET_TRIAL = 'get-trial',
}
